type PersistantStorageConfig = {
  storageKey: string;
  storageType: Storage;
};

export const nyBestillingConfig: PersistantStorageConfig = {
  storageKey: "ny-bestilling",
  storageType: sessionStorage,
};

export const languageConfig: PersistantStorageConfig = {
  storageKey: "language",
  storageType: localStorage,
};
